import { Box, Typography } from '@mui/material'
import { ResourceHeader, ResourceTitle } from '../components/ResourceComponents'

export default function PropertyMetrics() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mx: 10,
        my: 6,
      }}>
      <ResourceHeader>Understanding the Four Key Innovation Metrics</ResourceHeader>

      <Typography sx={{ whiteSpace: 'pre-line' }}>
        To make better investment and strategic decisions, it helps to understand not just how much a company is innovating, but
        how that innovation aligns with specific technology areas. These four metrics, IP Footprint, IP Similarity, IP Weight, and
        Pure Play % have been developed to help non-specialists evaluate innovation positioning clearly and consistently, using
        patent data.
        <ResourceTitle>1. IP Footprint – How Deep is Their Presence?</ResourceTitle>
        This metric shows how well a company’s patent activity is distributed across the same sectors as the target. It rewards
        companies that have depth and focus in those areas, and penalises portfolios that are scattered or misaligned. This helps
        gauge how embedded a company is within the specific innovation space being analysed.
        <ResourceTitle>2. IP Similarity – How Aligned Are Their Ideas?</ResourceTitle>
        This measures the closeness of the actual ideas in the patents comparing the language, concepts, and structure of the
        claims. It’s not just about having patents in the same category, but whether the peer company is working on the same kinds
        of problems and solutions. A high IP Similarity score means the companies are innovating in similar ways.
        <ResourceTitle>3. IP Weight – How Much Have They Invested?</ResourceTitle>
        IP Weight shows the number of patents a peer company holds within the same innovation space as the target. This is a good
        indicator of R&D effort, commercial intent, and strategic scale. A high score often signals a well-resourced, heavyweight
        competitor in the space.
        <ResourceTitle>4. Pure Play % – How Focused Are They?</ResourceTitle>
        This is the percentage of a company’s entire patent portfolio that overlaps with the target’s core technology space. A
        high Pure Play % means the company is a specialist, focused closely on a small number of themes. A low percentage suggests
        the company is more of a generalist, active across many unrelated areas.
        <ResourceTitle>Why It Matters</ResourceTitle>
        By combining these four signals, it becomes possible to assess a company’s relevance, intent, and positioning even if
        you’ve never worked with patent data before. This enables investors, strategists, and analysts to surface hidden
        competitors, assess risk, and identify focused innovators with far greater confidence.
      </Typography>
    </Box>
  )
}
